import script from "./MaterialAudioPlayerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialAudioPlayerCard.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialAudioPlayerCard.vue?vue&type=style&index=0&id=ed160c20&lang=css"

const __exports__ = script;

export default __exports__